// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:38:50

export default {
  "id": "snake-2048",
  "slug": "snake-2048",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6ee77ee8502d4eba86b4267af819f189-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6ee77ee8502d4eba86b4267af819f189/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Snake 2048",
      "description": "Start as a small cube in this thrilling online game! Eat smaller snakes, dodge stronger ones, and grow into a giant. Enjoy endless challenges, competitive leaderboards, and exciting gameplay. Play now and dominate the arena!",
      "instructions": "Desktop:\nThe snake turns with the cursor.\n\nMobile:\nUse the joystick to rotate the snake.",
      "genres": [
        ".IO",
        "Casual"
      ],
      "tags": [
        "2048",
        "arcade",
        "skill",
        "snake"
      ]
    },
    "zh-CN": {
      "title": "蛇2048",
      "description": "在这个激动人心的在线游戏中，从一个小方块开始！吞噬更小的蛇，躲避更强大的蛇，成长为巨兽。享受无尽的挑战，竞争的排行榜和精彩的玩法。现在开始游戏，称霸战场！",
      "instructions": "桌面：\n蛇随光标转向。\n\n移动端：\n使用摇杆旋转蛇。",
      "genres": [
        ".IO",
        "休闲"
      ],
      "tags": [
        "2048",
        "街机",
        "技巧",
        "贪吃蛇"
      ]
    },
    "zh-TW": {
      "title": "蛇2048",
      "description": "從一個小立方體開始，在這款刺激的網上遊戲中！吃掉較小的蛇，躲避較強大的蛇，並成長為一個巨無霸。享受無盡的挑戰、競爭性的排行榜和令人興奮的遊戲玩法。立刻遊玩，稱霸賽場！",
      "instructions": "桌面：\n蛇隨著滑鼠方向轉動。\n\n行動裝置：\n使用方向盤來旋轉蛇。",
      "genres": [
        ".IO",
        "休閒"
      ],
      "tags": [
        "2048",
        "街機",
        "技巧",
        "蛇遊戲"
      ]
    },
    "zh-HK": {
      "title": "蛇2048",
      "description": "作為一個小立方體在這款刺激的網上遊戲中開始吧！吃掉較小的蛇，避開較強大的蛇，並成為一個巨人。享受無盡的挑戰、競技排行榜和刺激的遊戲體驗。立即玩遊戲並征服場地！",
      "instructions": "桌面：\n蛇隨著滑鼠方向轉身。\n\n手機：\n使用摇桿來旋轉蛇隻。",
      "genres": [
        ".IO",
        "休闲"
      ],
      "tags": [
        "2048",
        "電玩場",
        "技巧",
        "蠍子遊戲"
      ]
    },
    "ja": {
      "title": "スネーク2048",
      "description": "このスリル満点のオンラインゲームで小さな立方体から始めよう！小さな蛇を食べ、強いものを避け、巨大に成長しよう。無限の挑戦、競争的なリーダーボード、そして興味深いゲームプレイを楽しむ。今すぐプレイしてアリーナを支配しよう！",
      "instructions": "デスクトップ:\nスネークはカーソルで回転します。\n\nモバイル:\nジョイスティックを使用してスネークを回転させます。",
      "genres": [
        ".IO",
        "カジュアル"
      ],
      "tags": [
        "2048",
        "アーケード",
        "スキル",
        "スネーク"
      ]
    },
    "ko": {
      "title": "사과 2048",
      "description": "이 흥미진진한 온라인 게임에서 작은 정육면체로 시작하세요! 작은 뱀을 먹고, 강한 뱀을 피하며 거대한 존재로 성장하세요. 끝없는 도전과 경쟁적인 랭킹, 흥미진진한 게임플레이를 즐겨보세요. 지금 바로 플레이하고 경기장을支配하세요!",
      "instructions": "데스크톱:\n뱀은 커서로 돌아갑니다.\n\n모바일:\n조이스틱으로 뱀을 회전시킵니다.",
      "genres": [
        ".ИО",
        "캐주얼"
      ],
      "tags": [
        "2048",
        "아케이드",
        "기술",
        "뱀"
      ]
    },
    "fr": {
      "title": "Serpent 2048",
      "description": "Commencez en tant que petit cube dans ce jeu en ligne épique ! Mangez des serpents plus petits, évitez les plus forts, et grandissez en géant. Profitez de défis infinis, de classements de leader compétitifs et de gameplay passionnant. Jouez maintenant et dominez l'arène !",
      "instructions": "Desktop :\nLe serpent se tourne avec le curseur.\n\nMobile :\nUtilisez le manette pour faire pivoter le serpent.",
      "genres": [
        ".IO",
        "Loisir"
      ],
      "tags": [
        "2048",
        "arcade",
        "compétence",
        "serpent"
      ]
    }
  }
};
